export default {"src":"/_next/static/media/truth-social-dark.5171d514.svg","height":144,"width":144,"blurWidth":0,"blurHeight":0};